<template>
	<div>
		<b-row class="justify-content-lg-center">
			<b-col>
				<b-card-title>{{ $t('worker_title_create') }}</b-card-title>
                <b-form @submit="submit" validate>
                    <b-row>
                        <b-col>
                            <div class="form-group form-row m-b-15">
                                <label class="col-form-label col-md-3">{{ $t('worker_form_label_firstname') }}</label>
                                <div class="col-md-9">
                                    <input v-model="firstname" type="text" class="form-control m-b-5" :placeholder="$t('worker_form_placeholder_firstname')" required />
                                </div>
                            </div>
                            <div class="form-group form-row m-b-15">
                                <label class="col-form-label col-md-3">{{ $t('worker_form_label_lastname') }}</label>
                                <div class="col-md-9">
                                    <input v-model="lastname" type="text" class="form-control m-b-5" :placeholder="$t('worker_form_placeholder_lastname')" />
                                </div>
                            </div>
                            <div class="form-group form-row m-b-15">
                                <label class="col-form-label col-md-3">{{ $t('worker_form_label_is_active') }}</label>
                                <div class="col-md-9">
                                    <b-form-checkbox
                                        size="lg"
                                        v-model="isActive"
                                        :value="true"
                                        :unchecked-value="false"
                                    />
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-lg-center">
                        <b-col>
                            <hr />
                            <a v-if="!hideButton" :href="`/worker`" type="button" class="btn btn-secondary mr-2">{{ $t('worker_button_back_to_list') }}</a>
                            <b-button type="submit" variant="primary">{{ $t('worker_button_send') }}</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
	</div>
</template>

<script>
export default {
    name: 'WorkerCreate',
    props: ['workerCreateCall', 'hideButton'],
    data() {
        return {
            firstname: '',
            lastname: '',
            isActive: true,
        }
    },
    methods: {
		submit() {
			event.preventDefault();
            this.workerCreateCall(JSON.stringify(
                {
                    firstname: this.firstname,
                    lastname: this.lastname,
                    isActive: this.isActive,
                }
            ));
		},
    },
}
</script>